/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { InjectionToken } from '@angular/core';

/** Default `n-slide-toggle` options that can be overridden. */
export interface NSlideToggleDefaultOptions {
  /** Whether toggle action triggers value changes in slide toggle. */
  disableToggleValue?: boolean;
}

/** Injection token to be used to override the default options for `n-slide-toggle`. */
export const N_SLIDE_TOGGLE_DEFAULT_OPTIONS = new InjectionToken<NSlideToggleDefaultOptions>(
  ' n-slide-toggle-default-options',
  {
    providedIn: 'root',
    factory: () => ({ disableToggleValue: false }),
  },
);
